import React, { useState, useEffect } from 'react';
import './index.less';

interface IIconProps{
  type: string,
  size: string,
  color?:any,
  clickEvent?:()=>void,
  symbel?:boolean,
  className?: string,
  style?:any,
}

export default function Icon(props:IIconProps):JSX.Element{
  const iconsTypes = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'];
  const [classNames, setClassNames ] = useState('');

  useEffect(()=>{
    const classes:Array<string> = ['iconfont'];
    if (props.size) {
      if (!iconsTypes.includes(props.size)) throw TypeError('you can choose \'xxs\'/\'xs\'/\'sm\'/\'md\'/\'lg\', default is "md" ');
      classes.push(props.size);
    }

    if (props.type) {
      classes.push('icon' + props.type);
    }
    setClassNames( classes.join(' '))
  },[props.type,props.size])

  // console.log(props.type)
  return (
    <div className={props.className} style={props.style}>
      {
        props.symbel ? (
          <div className={props.size}>
            <svg className="icon" aria-hidden="true">
              <use xlinkHref={'#icon' + props.type}></use>
            </svg>
          </div>
        )
          : <div className={classNames} onClick={props.clickEvent} style={props.color ? { color: props.color } : {}}></div>
      }
    </div>
  )
}

/*
export default class Icon extends Component {
  PropTypes = {
    type: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    color: PropTypes.string,
    clickEvent: PropTypes.func,
    symbel: PropTypes.bool,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      classNames: '',
    };
  }

  static getDerivedStateFromProps(props) {
    const iconsTypes = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'];
    const classes = ['iconfont'];

    if (props.size) {
      if (!iconsTypes.includes(props.size)) throw TypeError('you can choose \'xxs\'/\'xs\'/\'sm\'/\'md\'/\'lg\', default is "md" ');
      classes.push(props.size);
    }

    if (props.type) {
      classes.push('icon' + props.type);
    }

    return {
      classNames: classes.join(' '),
    };
  }


  render() {
    const { classNames } = this.state;
    const {
      symbel, type, size = 'md', className,
    } = this.props;
    return (
      <div className={className}>
        {
          symbel ? (
            <div className={size}>
              <svg className="icon" aria-hidden="true">
                <use xlinkHref={'#icon' + type}></use>
              </svg>
            </div>
          )
            : <div className={classNames} onClick={this.props.clickEvent} style={this.props.color ? { color: this.props.color } : {}}></div>
        }
      </div>
    );
  }
}
*/
